import React from 'react';
import { Unsplash } from './Unsplash';
import { UnsplashIcon } from './UnsplashIcon';
export const unsplashPicker = {
    name: 'Unsplash',
    icon: React.createElement(UnsplashIcon, null),
    component: Unsplash
};
